import { useSelector } from 'react-redux';
import {
  selectMilestoneMap,
  selectObjective,
  calculateIntervalRange,
} from '../store/selectors/intervalSelectors';
import { filterItemsForInterval } from '../utils/statusUtils';
import { RootState } from '../store/store';

export function useIntervalRange(forIntervalEnding: string, milestoneMapUuid: string) {
  const milestoneMap = useSelector((state: RootState) =>
    selectMilestoneMap(state, milestoneMapUuid),
  );
  if (!milestoneMap) return [undefined, undefined];
  return calculateIntervalRange(forIntervalEnding, milestoneMap);
}

export function useResultsAndComments(
  forIntervalEnding: string,
  objectiveUuid: string,
  milestoneMapUuid: string,
) {
  const objective = useSelector((state: RootState) =>
    state.map3Data.objectives.find((obj) => obj.uuid === objectiveUuid),
  );

  const [intervalStart, intervalEnd] = useIntervalRange(forIntervalEnding, milestoneMapUuid);

  // Use consistent boundary handling: exclude start, include end
  const results =
    intervalStart && intervalEnd
      ? filterItemsForInterval(objective?.results, intervalStart, intervalEnd)
      : [];
  const comments =
    intervalStart && intervalEnd
      ? filterItemsForInterval(objective?.comments, intervalStart, intervalEnd)
      : [];

  return {
    intervalStart,
    intervalEnd,
    results,
    comments,
  };
}
